import { Box, CircularProgress, SxProps, Theme } from '@mui/material';

const loadingStyles: SxProps<Theme> = {
  display: 'grid',
  alignContent: 'center',
  justifyContent: 'center',
  height: 'calc(100vh - 200px)',
};

export function PageLoading() {
  return (
    <Box sx={loadingStyles}>
      <CircularProgress />
    </Box>
  );
}
